import React, { Component } from "react";
import { Link, NavLink } from "react-router-dom";
import { BackToTop } from "./ui.js";

/* ============================================================
   LEVELUP ONE — Top navigation with dropdown menus
   (โครงสร้างเมนูตามเว็บต้นแบบ uplifttech.co)
   ============================================================ */

const MENU = [
  {
    label: "เกี่ยวกับเรา",
    to: "/about",
    children: [
      { label: "เรื่องราว", desc: "จุดเริ่มต้นและเส้นทางของเรา", to: "/story" },
      // { label: "บริษัท", desc: "ข้อมูลบริษัทและที่ตั้ง", to: "/company" },
      // { label: "ทีมงาน", desc: "คนเบื้องหลัง LevelUp One", to: "/teams" },
      { label: "วิสัยทัศน์", desc: "ทิศทางและพันธกิจ", to: "/vision" },
    ],
  },
  {
    label: "บริการ",
    to: "/services",
    children: [
      { label: "ผลิตภัณฑ์ SaaS", desc: "แพลตฟอร์มพร้อมใช้", to: "/services#saas-products" },
      { label: "พัฒนาตามความต้องการ", desc: "Custom Development", to: "/services#custom-development" },
      { label: "จัดหาทีมงาน IT", desc: "IT Talent / Outsource", to: "/services#it-talent" },
      { label: "โซลูชัน AI", desc: "AI Solutions", to: "/services#ai-solutions" },
      { label: "ที่ปรึกษา", desc: "Consulting & Architecture", to: "/services#consulting" },
      { label: "Brand Stage", desc: "แบรนด์และการตลาด", to: "/services#brand-stage" },
    ],
  },
  {
    label: "บทความ",
    to: "/blog",
    children: [
      { label: "ทั้งหมด", desc: "บทความทุกหมวด", to: "/blog" },
      { label: "Automation", desc: "ระบบอัตโนมัติ", to: "/blog?tag=Automation" },
      { label: "MarTech", desc: "เทคโนโลยีการตลาด", to: "/blog?tag=MarTech" },
      { label: "พัฒนาซอฟต์แวร์", desc: "Software Development", to: "/blog?tag=Software Development" },
      { label: "ออกแบบ UX/UI", desc: "UX/UI Design", to: "/blog?tag=UX/UI" },
    ],
  },
  { label: "นวัตกรรม", to: "/innovation" },
];

export default class NavbarComponent extends Component {
  state = { scrolled: false, open: false, mobileSub: null };

  componentDidMount() {
    this.onScroll = () => this.setState({ scrolled: window.scrollY > 8 });
    window.addEventListener("scroll", this.onScroll, { passive: true });
    this.onScroll();
  }
  componentWillUnmount() {
    window.removeEventListener("scroll", this.onScroll);
  }
  close = () => this.setState({ open: false, mobileSub: null });
  toggleSub = (label) => this.setState((s) => ({ mobileSub: s.mobileSub === label ? null : label }));

  render() {
    const { scrolled, open, mobileSub } = this.state;
    return (
      <>
      <nav className={`nx-nav ${scrolled ? "nx-nav--scrolled" : ""}`}>
        <div className="container">
          <div className="nx-nav__inner">
            <Link to="/" className="nx-brand" onClick={this.close}>
              <span className="nx-brand__mark">L</span>
              <span className="nx-brand__name">LevelUp<span> One</span></span>
            </Link>

            {/* ===== Desktop ===== */}
            <div className="nx-nav__links">
              {MENU.map((m) =>
                m.children ? (
                  <div className="nx-nav__item" key={m.label}>
                    <NavLink to={m.to} className={({ isActive }) => `nx-nav__link ${isActive ? "is-active" : ""}`}>
                      {m.label}<span className="nx-nav__caret">▼</span>
                    </NavLink>
                    <div className="nx-dropdown">
                      {m.children.map((c) => (
                        <Link key={c.label} to={c.to} className="nx-dropdown__link">
                          {c.label}<small>{c.desc}</small>
                        </Link>
                      ))}
                    </div>
                  </div>
                ) : (
                  <NavLink key={m.label} to={m.to} className={({ isActive }) => `nx-nav__link ${isActive ? "is-active" : ""}`}>
                    {m.label}
                  </NavLink>
                )
              )}
              <Link to="/login" className="nx-nav__login ms-2">เข้าสู่ระบบ</Link>
              <Link to="/register" className="nx-btn nx-btn--ghost" style={{ padding: "9px 18px" }}>สมัครสมาชิก</Link>
              <Link to="/booking" className="nx-btn nx-btn--primary" style={{ padding: "9px 20px" }}>พูดคุยกับเรา</Link>
            </div>

            <button
              className="nx-nav__toggle"
              aria-label="เมนู"
              aria-expanded={open}
              onClick={() => this.setState({ open: !open })}
            >
              <span />
            </button>
          </div>

          {/* ===== Mobile ===== */}
          <div className={`nx-mobile ${open ? "is-open" : ""}`}>
            {MENU.map((m) =>
              m.children ? (
                <div className="nx-mobile__group" key={m.label}>
                  <button className="nx-mobile__link w-100 text-start border-0 bg-transparent d-flex justify-content-between align-items-center" onClick={() => this.toggleSub(m.label)}>
                    {m.label}<span className="nx-nav__caret">{mobileSub === m.label ? "▲" : "▼"}</span>
                  </button>
                  {mobileSub === m.label && (
                    <div className="nx-mobile__sub">
                      {m.children.map((c) => (
                        <Link key={c.label} to={c.to} onClick={this.close}>{c.label}</Link>
                      ))}
                    </div>
                  )}
                </div>
              ) : (
                <NavLink key={m.label} to={m.to} className="nx-mobile__link" onClick={this.close}>{m.label}</NavLink>
              )
            )}
            <NavLink to="/login" className="nx-mobile__link" onClick={this.close}>เข้าสู่ระบบ</NavLink>
            <Link to="/register" className="nx-btn nx-btn--ghost mt-2" onClick={this.close}>สมัครสมาชิก</Link>
            <Link to="/booking" className="nx-btn nx-btn--primary mt-2" onClick={this.close}>พูดคุยกับเรา</Link>
          </div>
        </div>
      </nav>
      <BackToTop />
      </>
    );
  }
}
